
import { defineComponent, ref } from 'vue';
import Collapsible from '@/components/Collapsible.vue';
import EditModal from './EditModal.vue';
import { useRequestDataStore } from '@/store/request-data';
import { DrugTarget } from '@/service/models/request/computation/drug-target';
import { useMenuStateStore } from '@/store/menu-state';
import ChartSettingsModal from '@/components/ChartSettingsModal.vue';
import ConcentrationChart from '@/components/ConcentrationChart.vue';
import { useChartsStore } from '@/store/charts';

export default defineComponent({
    components: {
        ChartSettingsModal,
        Collapsible,
        ConcentrationChart,
        EditModal,
    },

    setup()
    {
        const requestData = useRequestDataStore();
        const menuState = useMenuStateStore();
        const chartStore = useChartsStore();

        const isTargetModalOpen = ref(false);
        const isSettingsModalOpen = ref(false);
        const modalTargetIndex = ref(0);
        const modalData = ref<DrugTarget|null>(null);

        function openTargetModal(targetIndex: number|null): void
        {
            if (targetIndex === null) {
                modalTargetIndex.value = requestData.targets.length;
                modalData.value = null;
            }
            else {
                modalTargetIndex.value = targetIndex;
                modalData.value = requestData.targets[targetIndex];
            }

            isTargetModalOpen.value = true;
        }

        function openSettingsModal(): void
        {
            isSettingsModalOpen.value = true;
        }

        function handleSave(payload: {index: number, data: DrugTarget})
        {
            // When insterting a new custom target, mark the menu entry as validated
            if (typeof requestData.targets[payload.index] === "undefined") {
                menuState.targetsValidated = true;
            }

            // Save data in the store
            requestData.targets[payload.index] = payload.data;
        }

        return {
            requestData,
            chartStore,
            openTargetModal, isTargetModalOpen, modalTargetIndex, modalData,
            handleSave,
            openSettingsModal, isSettingsModalOpen,
        };
    },
})
